<template>
  <div class="content-slider-wrapper slider-wrapper">
    <div class="carousel" ref="carousel">
      <div class="carousel__slide slider-inner-wrapper" v-for="(tripData, idx) in slidesData"
           :key="idx" :index="idx">
        <div class="slider-image">
          <responsive-concrete-image v-if="tripData.overrides && tripData.overrides.imagePath"
                                     :src="tripData.overrides.imagePath"
                                     :available-thumbnails='JSON.parse(tripData.overrides.imagePaths)'
                                     img-class="img-responsive image-pos-mitte"
                                     aspect-ratio="16/9"
                                     :lazyload="false"
                                     class="slider-image-inner"/>
          <responsive-image v-else-if="tripData.bilder"
                            :src="tripData.bilder.jpg_fallback_16x9"
                            :src-xs="tripData.bilder.img800_16x9"
                            :src-sm="tripData.bilder.img1000_16x9"
                            :src-md="tripData.bilder.img1200_16x9"
                            :src-lg="tripData.bilder.img1900_16x9"
                            aspect-ratio="16/9"
                            :lazyload="false"
                            img-class="img-responsive image-pos-mitte"
                            class="slider-image-inner"/>
        </div>
        <div class="slider-promo" v-if="tripData.overrides && tripData.overrides.content || tripData.tdbez">
          <div class="container">
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-4 col-md-offset-8">
                <a :href="url(tripData)" :target="target(tripData)" class="slider-promo-link"
                   v-if="tripData.overrides && tripData.overrides.content || tripData.tdbez">
                  <div class="promo-inner pull-right">
                    <div class="row">
                      <div class="col-sm-7 col-md-12 promo-description">
                        <div v-if="tripData.overrides && tripData.overrides.content"
                             v-html="tripData.overrides.content"></div>
                        <div v-else>
                          <div v-if="tripData.laender" class="country-wrapper">
                            <p class="country">{{ concatCountries(tripData) }}</p>
                          </div>
                          <h4>{{ tripData.tdbez }}</h4>
                          <p v-if="tripData.abreisedatentext" class="termine">{{ tripData.abreisedatentext }}</p>
                          <p v-else class="description">{{ tripData.beschreibung }}</p>
                        </div>
                      </div>
                      <div class="col-sm-5 col-md-12 promo-button">
                        <div class="row">
                          <button class="btn btn-primary btn-arrow" v-html="button(tripData)"></button>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style></style>
<script type="module">
import AnalyticsMixin from "../mixins/analytics-mixin";
import { Fancybox, Carousel, Panzoom } from "@fancyapps/ui";
import { Autoplay } from "@fancyapps/ui/dist/carousel.autoplay.esm.js";
Carousel.Plugins.Autoplay = Autoplay;

export default {
  name: "content-slider",
  props: {
    slidesData: Array,
    autoPlay: {
      type: Number,
      default: 0
    }
  },
  mixins: [AnalyticsMixin],
  data: function () {
    return {}
  },
  computed: {
    useAutoPlay: function() {
      return this.autoPlay && (this.slidesData.length > 1)
    },
    useCarousel: function() {
      return (this.slidesData.length > 1)
    }
  },
  methods: {
    concatCountries: function (item) {
      if (item) {
        var countryNames = [];
        if (item.laender) item.laender.forEach(function (c) {
          countryNames.push(c.bezeichnung);
        })
        return countryNames.join(', ');
      }
      return '';
    },
    url: function (item) {
      if (item.overrides && item.overrides.buttonLink) {
        return item.overrides.buttonLink;
      }
      if (item.titel) return '/reise/' + this.sanitizeTitle(item.tdbez) + '-' + item.code;
      return '/reise/' + item.code;
    },
    button: function (item) {
      if (item.overrides && item.overrides.buttonText) {
        return item.overrides.buttonText;
      }
      if (item && item.ausgebucht === true) {
        return 'Alle Reisen ausgebucht';
      }
      if (item && item.anzahlabreisedaten === 0) {
        return 'Reise in Planung';
      }
      if (item) {
        var preis = new Intl.NumberFormat('de-CH', { style: 'currency', currency: 'CHF',minimumFractionDigits: 0,maximumFractionDigits: 0 }).format(item.startpreis);
        return item.dauer + " Tage ab CHF<strong>" + preis.replace('CHF', '') + ".–</strong>";
      }
    },
    target: function(item) {
      if (item.overrides && item.overrides.buttonTarget) {
        return item.overrides.buttonTarget;
      }
      return "_self";
    },
    hasTripData: function(item) {
      if (item.letztes_tourdata_update) return true;
      return false;
    },
    toggleRemember: function () {
      setCartState();
    }
  },
  mounted() {
    if(!this.useCarousel) return;
    var autoPlaySettings = false;
    if(this.useAutoPlay){
      autoPlaySettings = {
        timeout: this.autoPlay,
      }
    }
    var contentSlider = new Carousel(this.$refs.carousel, {
      Autoplay: autoPlaySettings,
      'slidesPerPage' : 1,
      'center': true,
      'infinite': true,
      'fill': true,
      'dots': false
    });
    if(this.useAutoPlay){
      contentSlider.plugins.Autoplay.start();
    }
  },
  created() {

  },
  updated() {

  }
}
</script>
